(function () {
  'use strict';
  if (document.documentElement.lang.toLowerCase() !== 'pl') return;
  var marker = document.getElementById('gw-pl-pl-entry-20261018-v1');
  if (!marker || marker.getAttribute('data-gw-pl-pl-country') !== 'PL') return;
  var root = (marker.getAttribute('data-gw-pl-pl-root') || '').replace(/\/+$/, '');
  var path = window.location.pathname.replace(/\/+$/, '');
  if (!/^\/pl(?:-pl)?$/.test(root) || path !== (marker.getAttribute('data-gw-pl-pl-path') || '').replace(/\/+$/, '')) return;
  var key = marker.getAttribute('data-gw-pl-pl-entry');
  var tails = {
    recorder: '/pages/gladwares-ai-recorder', cart: '/cart', faq: '/pages/faqs',
    contact: '/pages/content', refund: '/policies/refund-policy',
    privacy: '/policies/privacy-policy', shipping: '/policies/shipping-policy',
    terms: '/policies/terms-of-service', tracking: '/apps/17TRACK',
    recorder_product: '/products/magnetic-ai-powered-voice-recorder',
    headphones: '/products/2026-noise-cancelling-wireless-headphones',
    hub: '/products/8-in-1-dual-usb-c-hub',
    folding_keyboard: '/products/folding-keyboard-with-smart-trackpad',
    air_mouse: '/products/mini-m5-dual-mode-wireless-air-mouse-keyboard'
  };
  if (!tails[key] || path.toLowerCase() !== (root + tails[key]).toLowerCase()) return;
  var images;
  try { images = JSON.parse(marker.textContent).images; } catch (error) { return; }
  var alts = {
    "lux-img-1": "Gladwares MemoryCard AI Pro — nagrywanie, transkrypcja i podsumowania",
    "lux-img-1-1": "Gladwares MemoryCard AI Pro — nagrywanie, transkrypcja i podsumowania",
    "lux-img-2": "Zamień rozmowy w przejrzysty tekst",
    "lux-img-3": "Zapisuj pomysły, spotkania i wskazówki",
    "lux-img-4": "Transkrypcja, kluczowe punkty i zadania",
    "lux-img-5": "Zarządzaj nagraniami w aplikacji DOWAY",
    "lux-img-6": "Nagrywaj rozmowy i wracaj do szczegółów",
    "lux-img-7-1": "Nagrywanie i podsumowania spotkań",
    "lux-img-7-2": "Kluczowe punkty rozmów",
    "lux-img-7-3": "Notatki do nauki i pracy",
    "lux-img-7-4": "Uporządkuj spotkania i zadania",
    "lux-img-8-1": "Nagraj, zamień na tekst i podsumuj",
    "lux-img-8-2": "Znajdź najważniejsze punkty",
    "lux-img-8-3": "Podsumowanie spotkania z najważniejszymi punktami, ustaleniami i kolejnymi krokami",
    "lux-img-8-4": "Wróć do dowolnego momentu rozmowy",
    "lux-img-9-1": "E-mail po spotkaniu gotowy do wysłania",
    "lux-img-9-2": "Dane klientów zawsze pod ręką",
    "lux-img-9-3": "Sugestie AI dotyczące kolejnych kroków na podstawie rozmowy",
    "lux-img-9-4": "Profil klienta uzupełniany informacjami z kolejnych rozmów",
    "P5-1": "Nagrywanie jednym przyciskiem",
    "P5-2": "Transkrypcja i podsumowania bez abonamentu",
    "P5-3": "152 języki w aplikacji DOWAY",
    "P5-4": "Nagrywanie, transkrypcja i podsumowania",
    "P5-5": "64 GB — do 450 godzin nagrań",
    "P5-6": "Cienki magnetyczny dyktafon wielkości karty"
};
  function setImage(img, id) {
    var url = images[id];
    if (!img || img.tagName !== 'IMG' || !url) return;
    var hero = id === 'lux-img-1' || id === 'lux-img-1-1';
    var mobile = window.matchMedia('(max-width: 767.4999px)').matches;
    if (hero) {
      var visible = mobile ? id === 'lux-img-1-1' : id === 'lux-img-1';
      img.setAttribute('loading', visible ? 'eager' : 'lazy');
      img.setAttribute('fetchpriority', visible ? 'high' : 'auto');
    }
    if (img.getAttribute('src') !== url) img.setAttribute('src', url);
    img.setAttribute('data-src', url);
    img.setAttribute('data-srcset', url);
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.setAttribute('alt', alts[id] || '');
    var picture = img.closest('picture');
    if (picture) picture.querySelectorAll('source').forEach(function (source) {
      source.setAttribute('srcset', url);
      source.setAttribute('data-srcset', url);
    });
  }
  function imagesOnce() {
    if (key !== 'recorder') return;
    Object.keys(images).forEach(function (id) {
      if (id.indexOf('lux-img-') === 0) setImage(document.getElementById(id), id);
    });
    var thumbs = document.querySelectorAll('#lux-thumb-strip .lux-thumb');
    if (thumbs.length !== 6) return;
    thumbs.forEach(function (thumb, index) {
      var id = 'P5-' + (index + 1);
      thumb.setAttribute('data-pl-image', images[id]);
      thumb.setAttribute('data-pl-pl-image', images[id]);
      thumb.setAttribute('data-image', images[id]);
      thumb.setAttribute('aria-label', alts[id]);
      setImage(thumb.querySelector('img'), id);
    });
    var active = document.querySelector('#lux-thumb-strip .lux-thumb.is-active') || thumbs[0];
    setImage(document.getElementById('lux-main-image'), 'P5-' + (Array.prototype.indexOf.call(thumbs, active) + 1));
  }
  function localLinks(container) {
    var permitted = Object.keys(tails).map(function (name) { return tails[name].toLowerCase(); });
    container.querySelectorAll('a[href]').forEach(function (a) {
      var url;
      try { url = new URL(a.getAttribute('href'), window.location.origin); } catch (error) { return; }
      if (url.origin === window.location.origin) {
        var relative = url.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '');
        if (permitted.indexOf(relative.replace(/\/+$/, '').toLowerCase()) !== -1) {
          var target = root + relative + url.search + url.hash;
          if (a.getAttribute('href') !== target) a.setAttribute('href', target);
        }
      } else if (url.hostname === 'shopify.com' && url.pathname === '/9182642261/account/orders') {
        url.searchParams.set('locale', 'pl');
        url.searchParams.set('region_country', 'PL');
        a.setAttribute('href', url.href);
      }
    });
  }
  function bundleText() {
    document.querySelectorAll('#lux-bundle-area .engrave-input').forEach(function (input) {
      input.setAttribute('placeholder', 'Wpisz imię lub tekst');
    });
  }
  function miniCartText() {
    document.querySelectorAll('.mini-cart__item').forEach(function (item) {
      if (!item.querySelector('a[href*="/products/magnetic-ai-powered-voice-recorder"]')) return;
      item.querySelectorAll('.line-item').forEach(function (line) {
        if (line.childElementCount === 0 && /^\s*Engraving(?=\s|:|\d|$)/.test(line.textContent)) {
          line.textContent = line.textContent.replace(/^(\s*)Engraving/, '$1Grawer');
        }
      });
    });
    document.querySelectorAll('.cart_content').forEach(localLinks);
  }
  function galleryAltSync() {
    if (key !== 'recorder' || typeof MutationObserver === 'undefined') return;
    var main = document.getElementById('lux-main-image');
    if (!main || main.__gwBatch1GalleryAltSync) return;
    function sync() {
      var source = main.getAttribute('src');
      for (var index = 1; index <= 6; index++) {
        var id = 'P5-' + index;
        if (source === images[id]) {
          var next = alts[id] || '';
          if (main.getAttribute('alt') !== next) main.setAttribute('alt', next);
          return;
        }
      }
    }
    sync();
    var observer = new MutationObserver(sync);
    observer.observe(main, {attributes: true, attributeFilter: ['src']});
    main.__gwBatch1GalleryAltSync = true;
  }
  function init() {
    imagesOnce();
    galleryAltSync();
    localLinks(document);
    bundleText();
    miniCartText();
    var bundle = key === 'recorder' ? document.getElementById('lux-bundle-area') : null;
    if (bundle && typeof MutationObserver !== 'undefined') {
      var scheduled = false;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function () {
          scheduled = false;
          bundleText();
        });
      }).observe(bundle, {childList: true, subtree: true});
    }
    document.addEventListener('gw-pl-pl-cart-rendered', miniCartText);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();

